import { useState } from 'react';

import { CasRenderDate, CasTable } from 'src/compass/shared/components';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';

import RequestDocDialog from '../../shared/ClaimDetails/Requests/RequestDocDialog';

export default function SendInitialTab() {
  const [dialogRow, setDialogRow] = useState<any>(null);
  const [reloadTable, setReloadTable] = useState<Date | null>(null);

  return (
    <>
      <CasTable
        entity="Sce/Claims/SendInitial"
        update={reloadTable}
        includeExport={false}
        columns={[
          {
            field: 'insuredName',
            render: ({ row, column }: ICasRenderCellProps) => (
              <CasLink onClick={() => setDialogRow(row)}>
                {getCasTableCellValue({ row, column })}
              </CasLink>
            ),
          },
          { field: 'sces', label: '#SCEs' },
          { field: 'effectiveDate', render: CasRenderDate },
        ]}
        filters={[{ name: 'insuredName' }]}
      />
      {dialogRow && (
        <RequestDocDialog
          ids={dialogRow.ids}
          onClose={() => setDialogRow(null)}
          onUpdated={() => setReloadTable(new Date())}
        />
      )}
    </>
  );
}
